import React, { ReactNode, useState } from "react";
import { ImageSlide as ImageSlideFragment } from "@sonder/ui/source/styled/fragments/ImageSlide";

interface ImageSlideProps {
  children: ReactNode;
  height?: string;
  isPDF?: boolean;
}
export const ImageSlide = ({ children, height, isPDF }: ImageSlideProps) => {
  const [fullScreen, setFullScreen] = useState(false);
  return (
    <ImageSlideFragment
      fullScreen={fullScreen}
      height={height}
      isPDF={isPDF}
      title={fullScreen ? "Exit fullscreen" : "View fullscreen"}
      onClick={() => {
        setFullScreen(!fullScreen);
      }}
    >
      {children}
    </ImageSlideFragment>
  );
};
